import { render, staticRenderFns } from "./CoordinatorEducation.vue?vue&type=template&id=bbcf6832&"
import script from "./CoordinatorEducation.vue?vue&type=script&lang=js&"
export * from "./CoordinatorEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports